module.exports = __webpack_public_path__ + "img/英文版_库尔_北京.8b645613.webp";